import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import DeleteConfirmation from "../deleteConfirmation";
import Table from "./../Theme/Table.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Edit from "./Edit";
import Badge from "@mui/material/Badge";
import { Button } from "react-bootstrap";
import Add from "./Add";
import { useContext } from "react";
import { RoleContext } from "../RoleContext";
import TableSmalls from "../Theme/TableSmalls";
const PermissionsList = () => {
  const roleData = useContext(RoleContext);
  var role = JSON.parse(roleData);
  const [permissions, setPermissions] = useState([]);
  const [id, setId] = useState(null);
  const [data, setData] = useState(null);
  const getPermissions = async () => {
    const response = await axios.get("permissions/").then(notify());
    setPermissions(response.data);
  };
  const showAddModal = () => {
    setDisplayAddModal(true);
  };

  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };

  const [deleteMessage, setDeleteMessage] = useState(null);
  const [displayAddModal, setDisplayAddModal] = useState(false);
  const [displayConfirmationModal, setDisplayConfirmationModal] =
    useState(false);
  const showDeleteModal = (id, name) => {
    setId(id);
    setDeleteMessage(`Are you sure you want to delete this permission?`);
    setDisplayConfirmationModal(true);
  };

  const hideAddModal = () => {
    setDisplayAddModal(false);
  };
  const submitDelete = (id) => {
    // console.log(id);
    deletePermission(id);
    setDisplayConfirmationModal(false);
    // getPassengers();
  };
  const deletePermission = async (id) => {
    const response = await axios.delete("/permissions/" + id, {
      data: { id: id },
    });
    getPermissions();
  };

  const showEditModal = (id) => {
    setId(id);

    axios.get("/permission/" + id, {}).then((res) => {
      setData(res.data.permission);

      setDisplayEditModal(true);
    });
  };
  const [displayEditModal, setDisplayEditModal] = useState(false);

  // Hide add modal
  const hideEditModal = () => {
    setDisplayEditModal(false);
  };

  const edit = "permission";
  const detail = "viewPassenger";

  const notify = () =>
    toast.success("Permissions list loaded.", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

    let fetched = false;
  useEffect(() => {
    if (!fetched) {
      getPermissions();
      fetched = true;
    }

  }, []);
  const columns = React.useMemo(
    () => [
      {
        Header: "Info",
        columns: [
          {
            Header: "Permission Name",
            accessor: "perm_name",
          },
          {
            Header: "Description",
            accessor: "perm_description",
          },

          {
            Header: "Action",
            accessor: "action",
            disableFilters: true,
            Cell: (row) => (
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                }}
              >
                {role.filter(function (e) {
                  return e.perm_name === "edit_permission";
                }).length > 0 && (
                  <Link
                    to={""}
                    onClick={(e) => showEditModal(row.cell.row.original.id)}
                  >
                    <i className="fas fa-edit info" />
                  </Link>
                )}
                &nbsp;
                {role.filter(function (e) {
                  return e.perm_name === "delete_permission";
                }).length > 0 && (
                  <Link
                    to={""}
                    onClick={(e) => showDeleteModal(row.cell.row.original.id)}
                  >
                    <i className="fas fa-trash error" />
                  </Link>
                )}
              </div>
            ),
          },
        ],
      },
    ],
    []
  );

  return (
    <div className="content-wrappers">
      <br />
      <br />
      <ToastContainer />

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h3
                    className="card-title"
                    style={{ marginRight: 850 + "px" }}
                  >
                    List of Permissions
                  </h3>
                  <Button
                    onClick={() => showAddModal()}
                    className="btn btn-success bt"
                  >
                    Add Permission
                  </Button>
                </div>

                <div className="card-body">
                  <TableSmalls
                    columns={columns}
                    data={permissions}
                    edit={edit}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <DeleteConfirmation
        showModal={displayConfirmationModal}
        confirmModal={submitDelete}
        hideModal={hideConfirmationModal}
        id={id}
        message={deleteMessage}
      />
      {displayEditModal == true && (
        <Edit
          id={id}
          data={data}
          showModal={displayEditModal}
          hideModal={hideEditModal}
        />
      )}
      <Add showModal={displayAddModal} hideModal={hideAddModal} />
    </div>
  );
};
export default PermissionsList;
